import OptionsField from "./Root.svelte";
import Option from "./Option.svelte";

export default Object.assign(OptionsField, { Option });
